import { Modal, ModalContent, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import { useSnackbar } from '@components/snackbar';
import { AddIcon, CloudDownloadIcon, MinusIcon, WhiteboardTemplateIcon } from '@sketchnote/icons';
import * as React from 'react';
import { preventEvent, TDShapeType, TDSnapshot, Tooltip, useTldrawApp } from 'sn-wb-tldraw';
import { API } from 'src/api';
import { useAuth } from 'src/shared/hooks/use-auth';

import { SaveTemplate } from './SaveTemplate';

export const TemplateMenu = React.memo(function TemplateMenu() {
  const app = useTldrawApp();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isTemplateEditMode = app.useStore((s) => s.appState.isTemplateEditMode);
  const authData = useAuth((s) => s.userDetails);
  const [openSnackbar] = useSnackbar();

  const isSketchnoteMember =
    authData?.email.endsWith('sketchnote.co') ||
    authData?.email === 'placebonikhil@gmail.com' ||
    authData?.email === 'aayushlama26@gmail.com' ||
    authData?.email === 'swp.desai@gmail.com';

  const handleOpenModal = () => {
    app.selectAll();
    app.createTemplateCopy();
    onOpen();
  };

  const updateTemplate = () => {
    const template = app.appState.currentEditingTemplate;

    API.put('/whiteboard/template', {
      id: template._id,
      shapes: app.page.shapes,
      bindings: app.page.bindings,
      assets: app.document.assets,
      sections: app.page.sections,
    }).then((res) => {
      app.setTemplateEditMode(false);
      app.deleteAll();
      app.restoreStashedShapes();
      openSnackbar({
        text: 'Template successfully Updated',
        snackType: 'standard',
        position: 'bottom-center',
      });
    });
  };

  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: '13%',
          right: '2%',
          display: 'flex',
          pointerEvents: 'all',
          width: '32px',
          height: '32px',
          background: '#EEF1FC',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          borderRadius: '4px',
        }}
        onClick={() => {
          app.setTemplateLibrary(true);
        }}
      >
        <Tooltip label="Template Library" side="left">
          <WhiteboardTemplateIcon fill={'#FFD321'} />
        </Tooltip>
      </div>
      {isSketchnoteMember && (
        <div
          style={{
            position: 'absolute',
            top: '19%',
            right: '2%',
            display: 'flex',
            pointerEvents: 'all',
            width: '32px',
            height: '32px',
            background: '#EEF1FC',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            borderRadius: '4px',
          }}
        >
          <button onClick={handleOpenModal}>
            <CloudDownloadIcon />
          </button>
          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent style={{ height: '816px', maxWidth: '1088px', borderRadius: '4px' }}>
              <div>
                <SaveTemplate onClose={onClose} />
              </div>
            </ModalContent>
          </Modal>
        </div>
      )}

      {isTemplateEditMode && (
        <div
          style={{
            position: 'absolute',
            bottom: '8%',
            right: '38%',
            width: '326px',
            height: '56px',
            border: '1px solid #E2E4E9',
            background: 'white',
            boxShadow: '0px 2px 4px rgba(19, 23, 32, 0.06)',
          }}
          className="px-16 flex justify-center items-center gap-16"
        >
          <p className="text-sm font-regular italic">Editing template...</p>
          <button
            onClick={updateTemplate}
            className={`bg-blue-500 text-sm font-medium py-6 px-16 rounded-sm text-white`}
          >
            Update template
          </button>
        </div>
      )}
    </>
  );
});
